// extracted by mini-css-extract-plugin
module.exports = {"button":"HoldButton_button__1K5Mw"};